import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import styled, { keyframes } from 'styled-components'
import Typewriter from 'typewriter-effect'

// Animación para el gradiente
const fluido = keyframes`
  0% { background-position: 100% 50%; }
  50% { background-position: 0 100%; }
  100% { background-position: 100% 200%; }
`

const Section = styled.section`
  position: relative;
  background-color: #fff;
  background-size: cover;
  background-repeat: no-repeat;
  @media (max-width: 767px) {
    padding: 50px 0;
  }
`

const Overlay = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(255,255,255,.5);
  min-height: 600px;
  height: ${({ height }) => height}px;
`

const Heading2 = styled.h2`
  font-family: "Montserrat", sans-serif;
  font-size: 10vw;
  font-weight: 900;
  line-height: .81;
  text-transform: uppercase;
  background: linear-gradient(-45deg, #274fbd, #01d8fd, #14dfea, #3fc12a, #65ff00, #5406d9, #e912a3, #7a3bca, #C1EB18, #65ff00);
  background-size: 300%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${fluido} 10s linear infinite;
  user-select: none;

  @media (min-width: 768px) {
    margin-left: 4px;
  }
  @media (max-width: 767px) {
    font-size: 16vw;
    margin-left: 2px;
    margin-top: 80px;
  }
  @media (min-width: 768px) and (max-width: 1500px) {
    font-size: 11.5vw;
    margin-top: 120px;
  }
  @media (min-width: 1501px) and (max-width: 1600px) {
    font-size: 11.5vw;
  }
`

const Heading3 = styled.h3`
  font-size: 30px;
  font-family: Antonio-Light, sans-serif;
  line-height: 40px;
  color: #000;
  margin: 50px 0;

  @media (min-width: 768px) {
    margin-left: 4px;
  }
  @media (max-width: 767px) {
    margin-left: 2px;
    font-size: 20px;
    line-height: 20px;
  }
`

const Type = styled.div`
  font-size: 30px;
  line-height: 50px;
  color: #000;

  span {
    font-family: Antonio-Light, sans-serif;
  }

  @media (min-width: 768px) {
    margin-left: 6px;
  }
  @media (max-width: 767px) {
    margin-left: 2px;
    font-size: 20px;
    line-height: 20px;
  }
  @media (min-width: 768px) and (max-width: 1500px) {
    font-size: 23px;
    line-height: 20px;
  }
`

const Content = styled.div`
  position: relative;
  z-index: 10;
`

const WeMake = styled.span`
  display: block;
  margin-bottom: 8px;
  letter-spacing: 10px;
`

const Make = () => {
  const [height, setHeight] = useState(typeof window !== 'undefined' ? window.innerHeight : 0)

  useEffect(() => {
    const updateHeight = () => {
      setHeight(window.innerHeight)
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  return (
    <Section id="wemake">
      <Overlay height={height}>
        <Container>
          <Content>
            <Heading2>
              <WeMake>We</WeMake>
              <WeMake>Make It</WeMake>
              <WeMake>Possible</WeMake>
            </Heading2>
            <Heading3>
              <Type>
                <Typewriter
                  options={{
                    strings: [
                      'Resolvemos desafíos empresariales, con soluciones tecnológicas innovadoras',
                    ],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Type>
            </Heading3>
          </Content>
        </Container>
      </Overlay>
    </Section>
  )
}

export default Make
